import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import DigitalExcellenceHero from "./sections/DigitalExcellenceHero";
import SonicIdentity from "./sections/SonicIdentity";
import CoreCongressServices from "./sections/CoreCongressServices";
import TheFullGallery from "./sections/TheFullGallery";
import FindYourSpiritualHome from "./sections/FindYourSpiritualHome";
import UpcomingEvents from "./sections/UpcomingEvents";
import VenuePressAssets from "./sections/VenuePressAssets";
import LetsWorkTogether from "./sections/LetsWorkTogether";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <DigitalExcellenceHero />
      <SonicIdentity />
      <CoreCongressServices />
      <TheFullGallery />
      <FindYourSpiritualHome />
      <UpcomingEvents />
      <VenuePressAssets />
      <LetsWorkTogether />
      <Footer />
    </div>;
}